import { LINK_PREVIEW_TYPE, LinkPreviewViewer, } from 'wix-rich-content-plugin-link-preview/viewer';
export var typeMapper = function () {
    var _a;
    return (_a = {},
        _a[LINK_PREVIEW_TYPE] = {
            component: LinkPreviewViewer,
            classNameStrategies: {
                container: function (theme) { return theme['linkPreviewContainer']; },
                custom: function (componentData, theme, styles, isMobile) {
                    return theme['linkPreviewPlugin'];
                },
            },
        },
        _a);
};
//# sourceMappingURL=typeMapper.js.map